var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "float-l width-full" }, [
    _c("div", { staticClass: "header-section col-12 float-l bgcolor-cfe3ee" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "customer-name float-l colpie-87" }, [
        _c(
          "a",
          {
            staticClass: "back-btn-main",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.backButton()
              }
            }
          },
          [_c("i", { staticClass: "hi-icon icon-chatback " })]
        ),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass:
              "user-avtar-archived-img color-231f20 font-roboto-bold heading-text-16 line-height-20 agent-customer-name float-l width-full pt_10 pl_100 mb_0"
          },
          [_vm._v(" " + _vm._s(_vm.fullName) + "\n            ")]
        )
      ]),
      _vm._v(" "),
      _vm._m(2)
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "chat-btm-section-main chat-listing-main-mobile width-full float-l message-height"
      },
      [
        _c(
          "div",
          { staticClass: "chat-detail-main col-12 float-l" },
          [
            _vm._l(_vm.messageArrData, function(message, index) {
              return _vm.messageArrData && _vm.messageArrData.length > 0
                ? [
                    message.fromRole == "guest"
                      ? _c(
                          "div",
                          {
                            key: index,
                            staticClass: "user-chat-main colpie-85 float-l"
                          },
                          [
                            _vm._m(3, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "user-massage float-l width-full"
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "message-content color-333333 heading-text-14 line-height-20 float-l bgcolor-eff1f1 font-text-regular-benton radius-5 pt_10 p_12 mb_0"
                                  },
                                  [_vm._v(_vm._s(message.message) + " ")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "date color-888888 heading-text-11 line-height-16 float-l width-full font-text-regular-benton mb_0 pt_5 pl_12"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("filterDate")(
                                          message.created_date
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      : _c(
                          "div",
                          {
                            key: index,
                            staticClass: "admin-chat-main colpie-82 float-r"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "user-massage float-r width-full"
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "message-content color-333333 heading-text-14 line-height-20 float-r bgcolor-d6eef5 font-text-regular-benton radius-5 pt_10 p_12 mb_0"
                                  },
                                  [_vm._v(_vm._s(message.message))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "date color-888888 heading-text-11 line-height-16 float-r right width-full font-text-regular-benton mb_0 pt_5 pr_12"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("filterDate")(
                                          message.created_date
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                  ]
                : _vm._e()
            })
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "back-btn-chat float-l" }, [
      _c("a", { attrs: { href: "#" } }, [
        _c("i", { staticClass: "hi-icon icon-chatback" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticClass:
          "user-avtar-archived-img user-avtar-img float-l font-roboto-bold heading-text-14 line-height-16 bgcolor-d7b081 color-white"
      },
      [_c("img", { attrs: { src: "/static/images/default-img.png" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-right-header float-r" }, [
      _c("div", { staticClass: "nc-chat-right-dropdown" }, [
        _c("div", { staticClass: "dropdown" }, [
          _c(
            "button",
            {
              staticClass: "more-btn btn btn-primary dropdown-toggle",
              attrs: { type: "button", "data-toggle": "dropdown" }
            },
            [
              _c("span", { staticClass: "more-dot" }),
              _vm._v(" "),
              _c("span", { staticClass: "more-dot" }),
              _vm._v(" "),
              _c("span", { staticClass: "more-dot" })
            ]
          ),
          _vm._v(" "),
          _c("ul", { staticClass: "dropdown-menu" }, [
            _c("li", [
              _c(
                "a",
                {
                  attrs: {
                    href: "#",
                    "data-toggle": "modal",
                    "data-target": "#basicModal1"
                  }
                },
                [
                  _vm._v(" Email Chat "),
                  _c("span", [
                    _c("i", { staticClass: "fa fa-angle-right custom" })
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _c(
                "a",
                {
                  attrs: {
                    href: "#",
                    "data-toggle": "modal",
                    "data-target": "#basicModal"
                  }
                },
                [
                  _vm._v(" Forward Chat "),
                  _c("span", [
                    _c("i", { staticClass: "fa fa-angle-right custom" })
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _c("a", { attrs: { href: "#" } }, [
                _vm._v(" End Chat "),
                _c("span", [
                  _c("i", { staticClass: "fa fa-angle-right custom" })
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "user-img float-l" }, [
      _c("img", {
        attrs: { src: "/static/images/default-img.png", alt: "User Name" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d3a145ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3a145ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/List/ChatWindow.vue
// module id = null
// module chunks = 